export default function UnholsterLogo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 610.2 105.8" width="118.47" height="40">
      <g id="Capa_1-2" data-name="Capa 1">
        <g id="Unholster_Imagotipo" data-name="Unholster Imagotipo">
          <g id="Unholster_Imagotipo-2" data-name="Unholster Imagotipo-2">
            <g id="Logotipo">
              <path
                fill="#171b21"
                strokeWidth="0"
                d="m251.8,54.8c3.9,3.9,5.9,9.1,5.9,15.6v34.1h-11.9v-30.2c0-4.2-1.2-7.5-3.6-10.1-2.4-2.5-5.8-3.7-9.9-3.7s-7.8,1.3-10.4,3.9-3.9,6-3.9,10.1v30h-11.9v-54.2h11.9v7.5c4.3-5.9,10.4-8.8,18.3-8.8,6.4-.1,11.6,1.9,15.5,5.8h0Z"
              />
              <path
                fill="#171b21"
                strokeWidth="0"
                d="m316.6,54.8c3.9,3.9,5.9,9.1,5.9,15.6v34.1h-11.9v-30.2c0-4.2-1.2-7.5-3.6-10.1-2.4-2.5-5.8-3.7-9.9-3.7s-7.8,1.3-10.4,3.9-3.9,6-3.9,10.1v30h-11.9V27.9h11.9v30.2c4.3-6.1,10.4-9.1,18.3-9.1,6.4-.1,11.6,1.9,15.5,5.8h0Z"
              />
              <path
                fill="#171b21"
                strokeWidth="0"
                d="m340.7,97.6c-5.5-5.4-8.3-12.2-8.3-20.3s2.8-14.8,8.3-20.2c5.5-5.4,12.4-8.1,20.7-8.1s15.2,2.7,20.7,8.1,8.3,12.2,8.3,20.2-2.8,14.8-8.3,20.3-12.5,8.2-20.7,8.2-15.2-2.8-20.7-8.2Zm20.7-3.4c4.7,0,8.7-1.6,11.9-4.8s4.8-7.3,4.8-12.1-1.6-8.8-4.8-12-7.2-4.8-11.9-4.8-8.7,1.6-11.9,4.8c-3.3,3.2-4.9,7.2-4.9,12s1.6,8.9,4.9,12.1c3.2,3.2,7.2,4.8,11.9,4.8Z"
              />
              <path
                fill="#171b21"
                strokeWidth="0"
                d="m413.1,93.5h9.5v11h-21.5V27.9h11.9v65.6h.1Z"
              />
              <path
                fill="#171b21"
                strokeWidth="0"
                d="m433.7,100.7c-3.6-3.3-5.5-7.4-5.5-12.2h12.1c0,1.9.7,3.5,2.1,4.9,1.4,1.3,3.2,2,5.2,2s3.5-.6,4.9-1.7,2-2.5,2-4.1c0-3.4-3.2-5.9-9.6-7.6-10.7-2.7-16-8.2-16-16.7,0-5,1.8-9,5.4-11.9,3.5-3,7.9-4.4,13-4.4s9.8,1.6,13.3,4.8,5.3,7.1,5.3,11.7h-12.1c0-3.4-2.7-6.1-6.6-6.1-3.4,0-6.2,2.3-6.2,5.3,0,3.4,3.3,5.9,9.8,7.5,10.5,2.7,15.8,8.2,15.8,16.5,0,5.2-1.8,9.4-5.5,12.5s-8.2,4.6-13.7,4.6-10.1-1.7-13.7-5.1h0Z"
              />
              <path
                fill="#171b21"
                strokeWidth="0"
                d="m508.5,61h-14.2v32.4h14.2v11h-26.1v-43.4h-10.1v-10.8h10.1v-16h11.9v16h14.2v10.8h0Z"
              />
              <path
                fill="#171b21"
                strokeWidth="0"
                d="m570.9,81.9h-44.9c.9,4,2.8,7.2,5.7,9.5,3,2.4,6.5,3.6,10.6,3.6,6.8,0,12.5-3.1,14.9-7.8h12.9c-2,5.6-5.5,10-10.5,13.4s-10.8,5.1-17.4,5.1c-8.2,0-15.1-2.7-20.6-8.1s-8.3-12.2-8.3-20.3,2.8-14.8,8.3-20.2c5.5-5.4,12.3-8.1,20.6-8.1s15.2,2.7,20.8,8.1c5.5,5.5,8.2,12.2,8.2,20.4,0,1.7-.1,3.1-.3,4.4h0Zm-28.7-22.2c-3.9,0-7.3,1.1-10.2,3.4-2.9,2.3-4.9,5.3-5.9,9h32.2c-1-3.8-3-6.8-5.9-9-3-2.3-6.3-3.4-10.2-3.4h0Z"
              />
              <path
                fill="#171b21"
                strokeWidth="0"
                d="m593.5,59.1c4.3-6.4,9.9-9.6,16.7-9.7v12.2c-5.2,0-9.3,1.5-12.2,4.5-3,3-4.4,7-4.4,12v26.4h-11.9v-54.2h11.9v8.8h-.1Z"
              />
              <path
                fill="#171b21"
                strokeWidth="0"
                d="m179.9,31.1v44.8c0,5.3-1.7,9.6-4.9,12.8s-7.7,4.9-13.1,4.9-9.2-1.6-12.3-4.7c-3.1-3.1-4.7-7.4-4.7-12.6V31.1h-12.6v46.2c0,9.1,3.5,15.9,8.7,20.7,5.5,5,13.6,7.7,19.9,7.7,8.6,0,15.4-4.1,19.2-8.8v7.5h12.5V31.1h-12.7Z"
              />
            </g>
            <g id="Isotipo">
              <rect fill="#2150e0" x="27.9" y="55.7" width="20.9" height="48.7" />
              <path fill="#2150e0" d="M0,0v83.5c0,11.5,9.4,20.9,20.9,20.9V0H0Z" />
              <rect fill="#2150e0" x="55.7" y="83.5" width="20.9" height="20.9" />
              <rect fill="#2150e0" x="83.5" width="20.9" height="104.4" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
